import { defineStore } from 'pinia';
import api from '@/services/api';
import elemento_base_model from '@/shared/models/elemento_base_model.js';
import { getParamsUrl } from './elemento_base_utils.js';

const ENTIDAD = 'elemento-base';
export const useElementoBaseStore = defineStore('elementoBaseStore', {
  state: () => ({
    elementoBase: { ...elemento_base_model },
    elementosBase: [],
    page: 1,
    filters: {},
    elementoBaseConfig: {},
  }),
  actions: {
    async findAllElementosBaseHTTP(params) {
      const result = await api.get(
        `/${ENTIDAD}?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data) {
        this.elementosBase = [...result.data];
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async findElementoBasePorCodigoHTTP(Codigo) {
      const result = await api.get(`/${ENTIDAD}/${Codigo}`);
      if (result && result.data) {
        this.elementoBase = { ...elemento_base_model, ...result.data };
      }
    },
    async findElementoBaseConfigHTTP(Codigo, Modulo) {
      const result = await api.get(`/${ENTIDAD}/${Codigo}/config?modulo=${Modulo}`);
      if (result && result.data) {
        this.elementoBaseConfig = result.data;
      }
    },
    setPage(page) {
      this.page = page;
    },
    async firstElementoBase() {
      this.setPage(1);
      this.emptyList();
      await this.findAllElementosBaseHTTP();
    },
    emptyList() {
      this.elementosBase = [];
    },
  },
});
